import styled, { space, themeGet, device } from '@styled'
import { Link } from 'gatsby'

export const BoxImgInner = styled.div`
  margin-inline: auto;
  margin-block: 0;
  margin-left: 0;
  width: 100%;
`

export const BoxImgMedia = styled.div`
  margin-block-end: 25px;
  transition: ${themeGet('transition')};
  padding: 0;
  ${device.large} {
    padding: 0 10px;
    margin: 0 auto;
    margin-block-end: 0px;
  }
  max-width: fit-content;
  align-items: center;
  img {
    border-color: rgb(36, 67, 149);
    border-style: solid;
    border-width: 1px;
    max-height: 200px;
    ${device.xlarge} {
      max-height: 220px;
    }
  }
`

export const BoxImgContent = styled.div``

export const HeadingWrap = styled.h5`
  font-weight: 500;
  line-height: 1.67;
  margin-block-end: 25px;
  font-size: 22px;
  ${device.xlarge} {
    font-size: 24px;
  }
`

export const HeadingWrap2 = styled.h5`
  display: inline-block;
  font-weight: 500;
  line-height: 1.67;
  margin-block-end: 0;
  font-size: 16px;
  ${device.xlarge} {
    font-size: 18px;
  }
  &:hover {
    color: ${themeGet('colors.primary')};
    opacity: 1;
    visibility: visible;
    cursor: pointer;
    a {
      text-decoration: underline;
    }
  }
`

export const TextWrap = styled.p`
  color: ${themeGet('colors.text')};
  font-size: 16px;
  ${device.xlarge} {
    font-size: 18px;
  }
`

export const BoxImgLink = styled(Link)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  text-indent: -999999px;
`

export const BoxImgWrapper = styled.div`
  position: relative;
  background: #fff;
  padding-block-start: 40px;
  padding-block-end: 40px;
  padding-inline: 30px;
  display: flex;
  height: 100%;
  ${space};
`
